<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Test Settings
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-text-field
              :error-messages="messages.pass_mark"
              v-model="pass_mark"
              label="Passmark (%)"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Please set your Passmark for a test, this is a %.</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.agree_statement"
              v-model="agree_statement"
              label="Acknowledgement Statement"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Create you own Acknowledgement Statement on a course i.e. I acknowledge I have read & understood.</span>
                </v-tooltip>
              </template>
            </v-text-field>

          <v-text-field
              :error-messages="messages.question_limit"
              v-model="question_limit"
              label="Number of Question"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>How many test questions would you like at the end of the course?</span>
                </v-tooltip>
              </template>
            </v-text-field>

          <v-switch 
            v-model="random"
            class="input_switch"
          >
          <template v-slot:label>
            <div><strong class="grey800--text">Random Question</strong></div>
            <div class="ml-5">  
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Randomise the questions that are visible on the test at the end of the course.</span>
                </v-tooltip>
            </div>
          </template>
          </v-switch>
        </v-form>
      </v-col>
    </v-row>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="cancel-button"  @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="ml-4 add-course-button"  @click="updateAgreeStatement"
          >Update</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import testAPI from "@/api/test.js";
export default {
  name: "AddAgreeStatement",
  components: {},
  props: {
    id: {
      type: String,
      default: null
    },
    passMark: {
      type: Number,
      default: 80
    }
  },
  data() {
    return {
      quiz: {},
      pass_mark: 80,
      agree_statement: '',
      random:'',
      messages: {},
      loading: false,
      successMessage: "Settings have been updated",
      errorMessage: "Oops something went wrong",
      question_limit: 10
    };
  },
  computed: {
  },
  mounted() {
    this.getQuiz();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    updateAgreeStatement() {
      this.loading = true;
      testAPI
        .updateAgreeStatement(this.id, this.agree_statement,this.random,this.question_limit,this.pass_mark)
        .then((resp) => {
          this.closePanel();
          EventBus.$emit("STATEMENT_UPDATED", resp.data.data);
          this.loading = false;
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.loading = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getQuiz() {
      this.loading = true;
      testAPI.getTest(this.id).then(resp => {
          this.quiz = resp.data.data;
          this.agree_statement = this.quiz.agree_statement;
          this.random = this.quiz.is_random;
          this.question_limit = this.quiz.question_limit;
          this.pass_mark = this.quiz.pass_mark;
          this.loading = false;
      });
    }
  }
};
</script>
